import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import NormalLayoutContainer from '../../../../shared/NormalLayoutContainer'
import { PageTitle } from '../../../../../components/page-title'
import { Spinner } from '../../../../shared/Spinner'
import notify from '../../../../../utilities/notify'
import useMutation from '../../../../../hooks/useMutation'
import useQuery from '../../../../../hooks/useQuery'
import QUERY_KEYS from '../../../../../graphql/queryKeys'
import usersQuery from '../../../../../graphql/queries/users.js'
import updateUser from '../../../../../graphql/mutations/updateUser'
import HaulerTeamMemberEditForm from './components/HaulerTeamMemberEditForm'
import HaulerTeamMemberEditExplanation from './components/HaulerTeamMemberEditExplanation'
import { onlyNumbers } from '../../../../../utilities/stringUtilities'

export default function HaulerTeamEditPage () {
  const history = useHistory()
  const { id } = useParams()
  const { user } = useSelector(({ user: { user } }) => ({ user }))

  const { mutate: updateUserMutation, isLoading } = useMutation(updateUser, {
    onSuccess () {
      notify('success', 'Team Member Updated Successfully')
      history.push(`/hauler/team/${id}`)
    },
    onError () {
      notify('error', 'Failed to update user')
    }
  })

  const { data: { users }, isFetching: userListFetching } = useQuery([
    QUERY_KEYS.users,
    user.haulerId,
    null,
    null,
    null,
    null,
    [id]
  ],
  usersQuery,
  {
    enabled: Boolean(user.haulerId),
    onError () {
      notify('error', 'Unable to retrieve user')
    },
    placeholderData: { users: { nodes: [] } }
  })

  const cancelEdits = useCallback(() => {
    history.push(`/hauler/team/${id}`)
  }, [history, id])

  function handleSubmit (formValues) {
    formValues.primaryPhone = `+1${onlyNumbers(formValues.prettyPrimaryPhone)}`
    const inputValues = {
      id,
      ...formValues
    }
    updateUserMutation(inputValues)
  }

  if (userListFetching) return <Spinner isFetching />

  const [userToEdit] = users?.nodes ?? []
  return (
    <div>
      <NormalLayoutContainer showBackLink>
        <div className='container-fluid'>
          <PageTitle title={`Team Member ${userToEdit.firstName} ${userToEdit.lastName} Profile`}>
            <button
              className='btn btn-link pull-right push-down-very-small'
              onClick={cancelEdits}>
              Cancel
            </button>
          </PageTitle>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-7 col-lg-7'>
              <HaulerTeamMemberEditForm
                isFetching={userListFetching || isLoading}
                onSubmit={handleSubmit}
                initialValues={userToEdit}
              />
            </div>
            <div className='col-xs-12 col-md-4 col-md-offset-1'>
              <HaulerTeamMemberEditExplanation />
            </div>
          </div>
        </div>
      </NormalLayoutContainer>
    </div>
  )
}

HaulerTeamEditPage.propTypes = {}
